export default "__VITE_ASSET__CB7rnnB2__"